import { ClassificationScheme, ClassColor, Classification } from './ClassificationScheme';

export interface ClassificationByCode {
  [key: string]: { name: string; color: ClassColor; custom: boolean; visible: boolean };
}

interface HiddenByPointCloudId {
  [key: string]: number[];
}

export class ClassificationsInfo {
  classes: Classification[] = [];
  hiddenClassesByPointCloud: HiddenByPointCloudId = {};
  constructor() {
    this.classes = ClassificationScheme;
  }

  addCustomClass({ identifier, name, code, color }: { identifier: string; name: string; code: number; color: ClassColor }) {
    const newClass: Classification = {
      identifier,
      name,
      code,
      color,
      custom: true,
    };
    this.classes.push(newClass);
  }

  removeCustomClass({ identifier }: { identifier: string }) {
    this.classes = this.classes.filter((c) => c.identifier !== identifier);
  }

  getClassesForPointCloud({ pointcloudId }: { pointcloudId: string }) {
    return this.classes.map((classification) => {
      return {
        ...classification,
        visible: !this.hiddenClassesByPointCloud[pointcloudId]?.includes(classification.code),
      };
    });
  }

  getSortedClassesForPointCloud(pointcloudId: string) {
    const classesForPointcloud = this.getClassesForPointCloud({ pointcloudId });
    return classesForPointcloud.reduce((sortedClasses: ClassificationByCode, classItem) => {
      const { code: key, ...value } = classItem;
      sortedClasses[key] = value;
      return sortedClasses;
    }, {});
  }
}
